import { useMemo } from 'react';

import { useSelection } from 'craft/hooks';
import { useEditor } from 'craft/hooks/useEditor';

// we have focus if the focused element's ancestors contains our parent OR our parent is the focussed element
export const useHasFocusWithinColumnSet = (nodeId: string) => {
  const { selection } = useSelection();
  const { query } = useEditor();

  const hasFocus = useMemo(() => {
    if (selection.all.length === 0) {
      return false;
    }

    // if we ANY of selection is within our set then we have focus
    return (
      selection.all.findIndex((selected: string) =>
        query
          .node(selected)
          .ancestors(true)
          .find((n) => n === nodeId),
      ) > -1
    );
  }, [selection.all]);

  return { hasFocus };
};
